import { useMemo } from 'react';
import type { DSLeftNavigationT } from '../../react-desc-prop-types.js';

const itemDefaultProps: DSLeftNavigationT.ItemOptsT = {
  label: '',
  labelOverflow: 'truncate',
  selectable: true,
  focuseable: true,
  openable: false,
  closable: false,
  ariaLabel: undefined,
  ariaRole: 'menuitem',
  ariaExpanded: undefined,
  ariaDescribedBy: undefined,
};

const itemWithoutShadows = ['ds-left-nav-item-header', 'ds-left-nav-item-link', 'ds-left-nav-item-submenu'];

// Make use Item props with defaults
export const usePropsWithDefaults = (
  props: DSLeftNavigationT.ItemRendererT,
): Required<DSLeftNavigationT.ItemRendererT> => {
  const propsWithDefault = useMemo(() => {
    const itemWithDefaults = {
      CollapsedComponent: () => null,
      ...props.item,
      itemOpts: { ...itemDefaultProps, ...props.item.itemOpts },
    };
    return {
      minHeight: '48px',
      paddingTop: '12px',
      subitems: [],
      shadowStyle: (opened: boolean, type: string) => () =>
        `box-shadow: ${
          opened || !itemWithoutShadows.includes(type) ? 'inset 4px 0 0 0 #52A6EC' : 'inset 4px 0 0 0 white'
        }`,
      hasBorderBottom: false,
      borderBottomMr: '0px',
      ...props,
      item: itemWithDefaults,
    };
  }, [props]);

  return propsWithDefault as Required<DSLeftNavigationT.ItemRendererT>;
};
